import { APP_ROUTES, useAppTranslation } from "@/utils";
import type { OrderInfoVM } from "@payping/api/app/api/bnplConsumerTypes";
import { CuToman, PhRStoresront } from "@payping/icons";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import { Button, Card, Divider, Flex, Progress, Typography } from "@payping/web-components";
import { Link } from "react-router";

interface OrderItemProps {
  data: OrderInfoVM;
}
const PurchaseHistoryOrderItem = (props: OrderItemProps) => {
  const { t } = useAppTranslation();
  return (
    <Card size="small">
      <Flex vertical className="tw:w-full" gap={"middle"}>
        <Flex gap={"large"} vertical className="tw:w-full">
          <Flex gap={"small"} align="center">
            <Card size="small" classNames={{ body: "tw:p-2! tw:flex tw:items-center" }}>
              <PhRStoresront className="tw:p-0! tw:text-color-text-tertiary" width={20} />
            </Card>
            <Typography.Text className="tw:m-0!">{props.data.merchantBusinessName ?? ""}</Typography.Text>
          </Flex>
          <Flex vertical className="tw:w-full" justify="center" align="center" gap={"small"}>
            <Progress
              type="circle"
              percent={((props.data.paidInstallments ?? 1) * 100) / (props.data.totalInstallments ?? 1)}
              size={64}
              format={() => (
                <Flex vertical>
                  <Typography.Text className="tw:text-xs!">{`${props.data.paidInstallments ?? 1} ${t("common.from")} ${props.data.totalInstallments ?? 1}`}</Typography.Text>
                </Flex>
              )}
              strokeWidth={8}
            />
            <Typography.Text type="secondary" className="tw:text-xs!">
              {t("common.numberOfPayments")}
            </Typography.Text>
          </Flex>
          <Flex className="tw:w-full" justify="center" align="center" gap={"large"}>
            <Flex vertical gap={"4px"} align="center" justify="center">
              <Typography.Text type="secondary" className="tw:text-xs!">
                {t("common.paid")}
              </Typography.Text>
              <Flex align="center">
                <Typography.Text>
                  {formatLocalizedNumber({ value: props.data.paidInstallmentAmount ?? 0 })}
                </Typography.Text>
                <CuToman width={24} height={24} />
              </Flex>
            </Flex>
            <Divider type="vertical" className="tw:m-0! tw:h-12" />
            <Flex vertical gap={"4px"} align="center" justify="center">
              <Typography.Text type="secondary" className="tw:text-xs!">
                {t("common.remain")}
              </Typography.Text>
              <Flex align="center">
                <Typography.Text>
                  {formatLocalizedNumber({ value: props.data.remainedInstallmentAmount ?? 0 })}
                </Typography.Text>
                <CuToman width={24} height={24} />
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Divider className="tw:m-0! tw:w-full" />
        <Flex className="tw:w-full" justify="center" align="center">
          <Button type="link">
            <Link to={APP_ROUTES.home.orderDetail.url.replace(":code", props.data.trackingCode ?? "")}>
              {t("common.viewDetails")}
            </Link>
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
};
export default PurchaseHistoryOrderItem;
